import {useCallback} from "react";
import {
	DateRangeField,
	SelectField
} from "~/components/Forms";
import {
	strToTime,
	getGroupSelectOption
} from "~/utils";

function CallSourceReportSearch({filter, listGroup, userOptions = [], onChange}) {

	const groupOptions = Object.values(getGroupSelectOption(listGroup));

	const handleTimeChange = useCallback((value) => {
		let valueNew = [...value];
		valueNew[0] = strToTime(valueNew[0]);
		valueNew[1] = strToTime(valueNew[1]);
		if(onChange) onChange('time', valueNew);
	}, [onChange]);

	const handleGroupChange = useCallback((value) => {
		if(onChange) onChange('groupId', value);
	}, [onChange]);

	const handleUserChange = useCallback((value) => {
		if(onChange) onChange('userId', value);
	}, [onChange]);

	return (
		<div className="search-bar">
			<form className="form" autoComplete="off">
				<DateRangeField name="time" onChange={(value) => handleTimeChange(value)} />
				<SelectField defaultValue={filter.groupId} placeholder="Chọn nhóm" options={groupOptions} onChange={(value) => handleGroupChange(value)} />
				<SelectField
					defaultValue={filter.userId}
					placeholder="Chọn nhân viên"
					options={[{value: '', label: 'Tất cả nhân viên'}, ...userOptions]}
					onChange={(value) => handleUserChange(value)}
				/>
			</form>
		</div>
	)
}

export default CallSourceReportSearch;
